export default __webpack_public_path__ + "static/Minebest_2021_Introduction-686b85377248a105342ae2335a747f31.webm";